exports.data = [
	{
		tab: "Hacktoberfest",
		role: "Open-Source Participant",
		institute: "Hacktoberfest",
		instituteLink: "https://hacktoberfest.digitalocean.com/",
		date: "1 October 2021 -31 October 2021",
		description: [
			"An event where a participant has to work on projects and solve different issues",
			"Contributed in open-source projects",
			"Completed Hacktoberfest"
		],
	},

	{
		tab: "TEDXMNNIT",
		role: "Marketing Coordinator",
		institute: "TEDXMNNIT",
		instituteLink: "https://www.facebook.com/TEDxMNNIT/",
		date: "March 2022 to April 2022",
		description: [
			"TEDx is a grassroots initiative, created in the spirit of TED’s overall mission to research and discover “ideas worth spreading”. ",
			"Contacted Sponsors for the event, collaborated with different TEDx speakers.",
		],
	},
	
	{
		tab: "TFP",
		role: "Content writer",
		institute: "TheFarmpedia",
		instituteLink: "https://thefarmpedia.com/",
		date: "July 2021 to January 2022",
		description: [
			"A digital initiative which will help build an ecosystem that nurtures innovation.",
			"Curated Content for TFP social media pages, collaborated with design and social media team.",
			"Worked as a social media manager for 1 month in absence of the previous one"
		],
	},

	{
		tab: "Adverto",
		role: "Content writer",
		institute: "Adverto",
		instituteLink: "https://thefarmpedia.com/",
		date: "January 2021 to March 2021",
		description: [
			"Content Writing for EduTech Companies",
			"Curated content for different Edutech companies",
			"Helped many aspirants through my content to chose right path for them."
		],
	},

	

	{
		tab: "Rotaract Club",
		role: "Volunteer",
		institute: "Rotaract Club MNNIT",
		instituteLink: "https://www.facebook.com/rotaractmnnit/",
		date: "August 2021 to Present",
		description: [
			"Participated in Winter Cloth Donation Drive",
			"Visited Old Age Home and Blind School",
		],
	},

];
